import { render, staticRenderFns } from "./AIEvaluationComponent_v2.vue?vue&type=template&id=9167aa30&scoped=true&"
import script from "./AIEvaluationComponent_v2.vue?vue&type=script&lang=js&"
export * from "./AIEvaluationComponent_v2.vue?vue&type=script&lang=js&"
import style0 from "./AIEvaluationComponent_v2.vue?vue&type=style&index=0&id=9167aa30&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9167aa30",
  null
  
)

export default component.exports